export const faqs = [
  {
    id: 1,
    question: {
      english: "How can I create a Snapseed QR code?",
      hindi: "मैं स्नैपसीड क्यूआर कोड कैसे बना सकता हूँ?"
    },
    answer: {
      english: 'Open Snapseed and edit your photo. Then tap Menu > QR Look > Create QR Look. Save the QR code image that appears. You can also <a href="/collection">explore our preset collection</a> to get inspired.',
      hindi: 'Snapseed खोलें और अपनी तस्वीर एडिट करें। फिर मेनू > QR Look > Create QR Look पर टैप करें। जो QR कोड दिखाई देता है उसे सेव करें। आप प्रेरणा के लिए हमारे <a href="/collection">प्रीसेट संग्रह</a> को भी देख सकते हैं।'
    }
  },
  {
    id: 2,
    question: {
      english: "How can I use someone else's QR code?",
      hindi: "मैं किसी और का QR कोड कैसे इस्तेमाल करूँ?"
    },
    answer: {
      english: 'Open your photo in Snapseed. Tap Menu > QR Look > Scan QR Look. Point your camera at the QR code and wait for it to scan. Need codes to try? Visit our <a href="/collection">QR preset collection</a>.',
      hindi: 'अपनी तस्वीर Snapseed में खोलें। मेनू > QR Look > Scan QR Look पर टैप करें। QR कोड की ओर कैमरा रखें और स्कैन होने दें। ट्राई करने के लिए <a href="/collection">हमारा प्रीसेट संग्रह</a> देखें।'
    }
  },
  {
    id: 3,
    question: {
      english: "Can I use multiple QR codes on one photo?",
      hindi: "क्या मैं एक फोटो पर कई QR कोड इस्तेमाल कर सकता हूँ?"
    },
    answer: {
      english: "Yes! After applying one QR code, you can scan another. Keep adding codes until you're satisfied with the result.",
      hindi: "हाँ! एक QR कोड लगाने के बाद आप दूसरा स्कैन कर सकते हैं। जब तक लुक पसंद न आ जाए, कोड जोड़ते रहें।"
    }
  },
  {
    id: 4,
    question: {
      english: "What if the QR code doesn't scan?",
      hindi: "अगर QR कोड स्कैन नहीं होता तो क्या करें?"
    },
    answer: {
      english: "Clean your camera lens. Ensure good lighting and adjust your phone's distance from the code. Try rescanning if needed.",
      hindi: "कैमरा लेंस साफ करें, रोशनी अच्छी रखें और फोन की दूरी बदलकर दोबारा स्कैन करने की कोशिश करें।"
    }
  },
  {
    id: 5,
    question: {
      english: "Will QR codes work on any photo?",
      hindi: "क्या QR कोड किसी भी तस्वीर पर काम करता है?"
    },
    answer: {
      english: 'Yes! QR codes work on all photos. But some filters work better on certain types, like portraits vs landscapes. Visit our <a href="/collection">collection</a> to find presets by style.',
      hindi: 'हाँ! QR कोड सभी तस्वीरों पर काम करता है। लेकिन कुछ फिल्टर खासतौर पर कुछ फोटो टाइप पर बेहतर लगते हैं जैसे पोर्ट्रेट बनाम लैंडस्केप। विभिन्न शैलियों के प्रीसेट्स के लिए <a href="/collection">हमारा संग्रह</a> देखें।'
    }
  },
  {
    id: 6,
    question: {
      english: "Can I share my QR codes online?",
      hindi: "क्या मैं अपने QR कोड ऑनलाइन शेयर कर सकता हूँ?"
    },
    answer: {
      english: "Yes! Save your QR code as an image and share it via social media, messaging apps, or email. Anyone with Snapseed can use it.",
      hindi: "हाँ! QR कोड को इमेज के रूप में सेव करें और सोशल मीडिया, मैसेज या ईमेल के ज़रिए शेयर करें। कोई भी जिसे Snapseed है, इसे यूज़ कर सकता है।"
    }
  },
  {
    id: 7,
    question: {
      english: "Will QR codes work if I change my phone?",
      hindi: "अगर मैं फोन बदल दूँ तो क्या QR कोड काम करेगा?"
    },
    answer: {
      english: "Yes! QR codes work on any device with Snapseed installed. They're like universal recipes for editing.",
      hindi: "हाँ! QR कोड किसी भी डिवाइस पर काम करते हैं जिसमें Snapseed इंस्टॉल हो। ये एडिटिंग की यूनिवर्सल रेसिपी की तरह होते हैं।"
    }
  },
  {
    id: 8,
    question: {
      english: "How many QR codes can I save?",
      hindi: "मैं कितने QR कोड सेव कर सकता हूँ?"
    },
    answer: {
      english: 'As many as you want! Name them clearly like "Sunset Glow" or "Bright Portrait" for easy identification. See examples in our <a href="/collection">Snapseed QR collection</a>.',
      hindi: 'जितने चाहें! उन्हें पहचानने के लिए स्पष्ट नाम दें जैसे "सनसेट ग्लो" या "ब्राइट पोर्ट्रेट"। उदाहरण के लिए <a href="/collection">हमारा स्नैपसीड संग्रह</a> देखें।'
    }
  },
  {
    id: 9,
    question: {
      english: "What if I make a mistake while creating a QR code?",
      hindi: "अगर मैं QR कोड बनाते समय गलती कर दूँ तो क्या होगा?"
    },
    answer: {
      english: "No problem! Just create a new one. Your old QR codes stay safe unless you delete them.",
      hindi: "कोई बात नहीं! बस एक नया QR कोड बना लें। पुराने कोड तब तक सुरक्षित रहते हैं जब तक आप उन्हें हटाएं नहीं।"
    }
  },
  {
    id: 10,
    question: {
      english: "Do QR codes affect my original photo?",
      hindi: "क्या QR कोड मेरी मूल तस्वीर को बदल देता है?"
    },
    answer: {
      english: "No! Your original photo remains untouched. QR codes only apply edits—like a transparent layer on top.",
      hindi: "नहीं! आपकी मूल तस्वीर वैसी की वैसी रहती है। QR कोड सिर्फ एडिट्स जोड़ते हैं, जैसे कि ऊपर एक ट्रांसपेरेंट लेयर हो।"
    }
  }
];
